import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import FormCertificateAnpr, {
  CertificatesAnprForm,
} from 'system/components/certificates-anpr/form';
import { CommonCertificatesAnprCrumbs } from '../constants';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const CertificateAnprNewPage = (): React.ReactElement => {
  const insertCertificateAnpr = useHttpClient(`${__MANAGEMENT_API_URL__}/postazione-anpr`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: CertificatesAnprForm | undefined) => {
      (
        insertCertificateAnpr({
          data: {
            codiceOperatoreAnpr: formValues?.operatorCode || undefined,
            note: formValues?.contextLastUpdate || undefined,
            aliasCertificato: formValues?.alias || formValues?.code || undefined,
            certificato: formValues?.certificateUpload?.raw?.split(',')[1] || undefined,
            codicePostazioneAnpr: formValues?.code || undefined,
            dataFineValidita: formValues?.endValidityDate?.toFormat('yyyy-MM-dd'),
            dataInizioValidita: formValues?.startValidityDate?.toFormat('yyyy-MM-dd'),
            password: formValues?.password,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/certificati-postazione');
      });
    },
    [insertCertificateAnpr, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonCertificatesAnprCrumbs,
          {
            name: 'Nuovo Certificato postazione anpr',
          },
        ]}
        base="sistema"
      />
      <FormCertificateAnpr
        title="Nuovo Certificato postazione anpr"
        onOk={onSubmit}
        isNew
        onCancel={() => {
          navigate('/sistema/certificati-postazione');
        }}
      />
    </Fragment>
  );
};

CertificateAnprNewPage.displayName = 'Certificate anpr new page component';

export default CertificateAnprNewPage;
